// Case data — MM Byggeri & Rådgivning
const IMG = {
    // Bengtasvej 6
    diningHall: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/isx9gfa2_IMG_4877.jpg",
    exterior: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/pyiqkol6_IMG_2217.jpg",
    bathroomMirror: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/g64ls4m1_IMG_1905.jpg",
    chandeliers: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/zsh0ubku_IMG_3338.jpg",
    stairOverhead: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/2x9mqzk1_IMG_1914.jpg",
    oakDoorsDusk1: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/nwd3rofh_IMG_3370.jpg",
    corridorSteel: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/t6wrk8c6_IMG_3422.jpg",
    oakDoorsDusk2: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/orn8stmb_IMG_3386.jpg",
    // Mixed / general detail (case attribution to be confirmed)
    wallpaperHallway: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/y3louicg_IMG_2229.JPG",
    spiralStair: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/9rk3gccx_IMG_3364.jpg",
    sauna: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/nphjfbkx_IMG_2113.jpg",
    brassTap: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/pmc7fewk_IMG_2230.JPG",
    // Kystvej 37B
    kystHall: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/rhfmw4he_IMG_2294.JPG",
    kystCoffered: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/8ru2jyvc_IMG_2280.JPG",
    kystChevronFloor: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/h9u1oikv_IMG_2287.JPG",
    kystBrassShower: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/lrqe2o2k_IMG_2299.JPG",
    kystKitchenButler: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/urdy42g1_IMG_2279.JPG",
    kystKitchenHoodDetail: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/ae8c6ubr_IMG_2276.JPG",
    kystKitchenMain: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/16nuvgu2_IMG_2273.JPG",
    kystKitchenWide: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/wiribde0_IMG_2270.JPG",
    kystParquet: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/9r0yh5ta_IMG_2271.JPG",
    droneExterior: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/u2c7545q_DJI_20250603143338_0128_D.JPEG",
    copperDetail: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/egncyy9z_9.JPEG",
    kystDrone2: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/g72chsgt_DJI_20250603143351_0129_D.JPEG",
    kystCedarCopper: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/2rewyv1f_31.JPEG",
    kystMarbleShower2: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/prrrzpn1_IMG_2260.JPG",
    kystWallpaper: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/hzvkdfqp_IMG_2262.JPG",
    kystKitchenFull: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/5ru8g9n1_IMG_2269.JPG",
    kystCorridor: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/5ane5zb4_IMG_2264.JPG",
    kyst2231: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/u8wtnutq_IMG_2231.JPG",
    kyst2241: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/8speaqfe_IMG_2241.JPG",
    kyst2250: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/cylj20kx_IMG_2250.JPG",
    kyst2254: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/bhd7qyxq_IMG_2254.JPG",
    kyst2258: "https://customer-assets.emergentagent.com/job_elite-team-co/artifacts/vu3yxxh0_IMG_2258.JPG",
};

export const heroImages = IMG;

export const cases = [
    {
        slug: "bengtasvej-6",
        type: "renovation",
        title: { da: "Bengtasvej", en: "Bengtasvej" },
        subtitle: {
            da: "Renovering af historisk ejendom til eksklusivt gæste- og festhus",
            en: "Renovation of a historic property into an exclusive guest and event house",
        },
        location: { da: "Hellerup", en: "Hellerup" },
        year: "2025",
        scope: { da: "305 m²  ·  Hovedentreprise", en: "305 m²  ·  General contract" },
        architect: "—",
        hero: IMG.chandeliers,
        body: {
            da: [
                "På Bengtasvej i Hellerup har MM Byggeri & Rådgivning stået for en gennemgribende renovering af en historisk ejendom fra slutningen af 1800-tallet. Projektet blev udført som hovedentreprise og omfattede transformationen af et opkøbt nabohus til et eksklusivt fest- og gæstehus med respekt for både arkitektur, materialer og eksisterende konstruktioner.",
                "Ejendommen rummer en lang række specialløsninger og materialevalg i højeste kvalitet. Blandt andet specialbyggede kviste i egetræ, skiffertag, linolievinduer, massive Dinesen-planker på 400 mm, italienske fliser, kalkmalede vægge samt specialudført gaspejs og vinrum.",
                "Flere af de eksisterende konstruktioner blev bevaret og integreret som en aktiv del af det arkitektoniske udtryk, herunder synlige egetræsbjælker i køkkenet og åbningen mellem stue og førstesal, hvor en del af etagedækket blev fjernet for at skabe mere rumlighed og lys.",
                "Projektet er et godt eksempel på den type renoveringer, hvor detaljeniveau, materialeforståelse og respekt for den oprindelige bygning er afgørende for det samlede resultat. Her handler det ikke kun om at bygge nyt, men om at skabe en helstøbt oplevelse, hvor arkitektur, håndværk og stemning hænger naturligt sammen.",
            ],
            en: [
                "On Bengtasvej in Hellerup, MM Byggeri & Rådgivning carried out a comprehensive renovation of a historic property from the late 1800s. Executed as a general contract, the project transformed an acquired neighbouring house into an exclusive guest and event house with respect for architecture, materials and existing structures.",
                "The property holds a long list of custom solutions and material choices of the highest quality — including bespoke oak dormers, slate roofing, linseed-oil windows, solid 400 mm Dinesen planks, Italian tiles, lime-painted walls and a custom-built gas fireplace and wine room.",
                "Several existing structures were preserved and integrated as an active part of the architectural expression — including visible oak beams in the kitchen and the opening between the living room and first floor, where part of the floor slab was removed to create more spatial flow and light.",
                "The project is a clear example of the type of renovation where attention to detail, material understanding and respect for the original building are decisive for the result. It is not only about building new, but about creating a coherent experience where architecture, craft and atmosphere belong naturally together.",
            ],
        },
        gallery: [
            IMG.diningHall,
            IMG.exterior,
            IMG.bathroomMirror,
            IMG.chandeliers,
            IMG.wallpaperHallway,
            IMG.oakDoorsDusk1,
            IMG.corridorSteel,
            IMG.oakDoorsDusk2,
            IMG.spiralStair,
            IMG.stairOverhead,
            IMG.sauna,
        ],
        materials: {
            da: [
                "Specialbyggede egetræs-kviste",
                "Skiffertag",
                "Linolievinduer",
                "Dinesen-planker 400 mm",
                "Italienske fliser",
                "Kalkmalede vægge",
                "Gaspejs & vinrum",
            ],
            en: [
                "Custom oak dormers",
                "Slate roofing",
                "Linseed-oil windows",
                "Dinesen planks, 400 mm",
                "Italian tiles",
                "Lime-painted walls",
                "Gas fireplace & wine room",
            ],
        },
    },
    {
        slug: "kystvej-37b",
        type: "summerhouse",
        title: { da: "Kystvej", en: "Kystvej" },
        subtitle: {
            da: "Eksklusivt sommerhus opført fra bunden på en af Danmarks mest attraktive adresser",
            en: "Exclusive summer house built from the ground up on one of Denmark's most attractive addresses",
        },
        location: { da: "Hornbæk", en: "Hornbæk" },
        year: "2025",
        scope: { da: "380 m²  ·  Hovedentreprise", en: "380 m²  ·  General contract" },
        architect: "—",
        hero: IMG.kyst2250,
        body: {
            da: [
                "På Kystvej i Hornbæk har MM Byggeri & Rådgivning opført et nyt sommerhus på 380 m² som hovedentreprise. Projektet er placeret på en af Danmarks mest eksklusive sommerhusveje og er skabt med kompromisløst fokus på materialer, detaljer og den samlede oplevelse af huset.",
                "Projektet omfattede blandt andet udgravning til fuld kælder under krævende forhold, hvor grundvand løbende skulle pumpes væk for at kunne etablere konstruktionen korrekt.",
                "Selve huset er opført som træhus og udført med en lang række eksklusive materialevalg, herunder canadiske rødcederspån, kobberdetaljer, naturstensgulve, italienske fliser, egetræsgulve i stor sildebensstav samt specialolierede overflader. Vinduer og døre er leveret af Skjern Vinduer, mens huset desuden er udstyret med integrerede skydedøre, specialtapeter og håndstrøgne overflader fra Farrow & Ball.",
                "Indvendigt er der arbejdet med specialfremstillede egetræssnedkerløsninger til både køkken og skabe, granitbordplader samt et fuldt integreret el-system, hvor store dele af huset styres digitalt via skærme.",
                "Kombinationen af materialer, proportioner og specialløsninger skaber et sommerhus med en rolig og eksklusiv atmosfære, hvor både funktionalitet og æstetik er tænkt ned i detaljen. Projektet understreger MM Byggeri & Rådgivnings tilgang til eksklusive boliger og sommerhuse, hvor håndværk, rådgivning og arkitektonisk forståelse går hånd i hånd gennem hele processen.",
            ],
            en: [
                "On Kystvej in Hornbæk, MM Byggeri & Rådgivning built a new 380 m² summer house as a general contract. The project sits on one of Denmark's most exclusive summer house roads and was created with an uncompromising focus on materials, detail and the overall experience of the house.",
                "Among other things, the project involved excavation for a full basement under demanding conditions where groundwater had to be continuously pumped out to establish the construction correctly.",
                "The house itself is built as a timber house and executed with a long list of exclusive material choices — Canadian red cedar shingles, copper details, natural stone floors, Italian tiles, oak floors in large herringbone, and custom-oiled surfaces. Windows and doors are supplied by Skjern Vinduer, while the house is also fitted with integrated sliding doors, custom wallpapers and hand-applied Farrow & Ball finishes.",
                "Inside, the work includes custom oak joinery for both kitchen and cabinetry, granite countertops and a fully integrated electrical system in which large parts of the house are controlled digitally via screens.",
                "The combination of materials, proportions and bespoke solutions creates a summer house with a calm and exclusive atmosphere where function and aesthetics are considered down to the last detail. The project underlines MM Byggeri & Rådgivning's approach to exclusive homes and summer houses — where craft, advice and architectural understanding go hand in hand throughout the process.",
            ],
        },
        gallery: [
            IMG.kystHall,
            IMG.droneExterior,
            IMG.kystDrone2,
            IMG.kystCedarCopper,
            IMG.copperDetail,
            IMG.kystCoffered,
            IMG.kystKitchenFull,
            IMG.kystKitchenMain,
            IMG.kystKitchenWide,
            IMG.kystKitchenHoodDetail,
            IMG.kystKitchenButler,
            IMG.kystWallpaper,
            IMG.kystCorridor,
            IMG.kyst2231,
            IMG.kyst2241,
            IMG.kyst2250,
            IMG.kyst2254,
            IMG.kyst2258,
            IMG.kystParquet,
            IMG.kystChevronFloor,
            IMG.kystMarbleShower2,
            IMG.kystBrassShower,
        ],
        materials: {
            da: [
                "Canadiske rødcederspån",
                "Kobberdetaljer",
                "Naturstensgulve",
                "Italienske fliser",
                "Egetræ i stor sildebensstav",
                "Skjern Vinduer",
                "Farrow & Ball overflader",
                "Granitbordplader",
            ],
            en: [
                "Canadian red cedar shingles",
                "Copper details",
                "Natural stone floors",
                "Italian tiles",
                "Oak in large herringbone",
                "Skjern Vinduer",
                "Farrow & Ball finishes",
                "Granite countertops",
            ],
        },
    },
];

export const team = [
    {
        name: "Martin Madsen",
        roleDa: "Stifter & Indehaver",
        roleEn: "Founder & Owner",
        bioDa: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod.",
        bioEn: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod.",
        portrait:
            "https://static.wixstatic.com/media/364444_8528ecff58b94b94b7de6d05affe8402~mv2.jpg",
    },
    {
        name: "Anders Lund",
        roleDa: "Projektleder",
        roleEn: "Project Manager",
        bioDa: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
        bioEn: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
        portrait:
            "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&q=80",
    },
    {
        name: "Sofie Krogh",
        roleDa: "Indretningsarkitekt",
        roleEn: "Interior Architect",
        bioDa: "Ut enim ad minim veniam quis nostrud exercitation.",
        bioEn: "Ut enim ad minim veniam quis nostrud exercitation.",
        portrait:
            "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80",
    },
    {
        name: "Niels Hoff",
        roleDa: "Medaljetømrer",
        roleEn: "Master Carpenter",
        bioDa: "Duis aute irure dolor in reprehenderit in voluptate velit esse.",
        bioEn: "Duis aute irure dolor in reprehenderit in voluptate velit esse.",
        portrait:
            "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80",
    },
    {
        name: "Mette Holm",
        roleDa: "Byggeleder",
        roleEn: "Construction Manager",
        bioDa: "Excepteur sint occaecat cupidatat non proident sunt in culpa.",
        bioEn: "Excepteur sint occaecat cupidatat non proident sunt in culpa.",
        portrait:
            "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&q=80",
    },
    {
        name: "Frederik Borg",
        roleDa: "Tømrer",
        roleEn: "Carpenter",
        bioDa: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem.",
        bioEn: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem.",
        portrait:
            "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=600&q=80",
    },
];
